import React from 'react'
import { useTranslation } from 'react-i18next'
import { useAPI } from '../../hooks/useAPI'
import { getCompanyInfo, getPlatformInfo } from '../../services/api/about'
import CompanyInfo from '../../components/business/Aboutus/CompanyInfo'
import PlatformInfo from '../../components/business/Aboutus/PlatformInfo'

const AboutPage = () => {
  const { t, i18n } = useTranslation()
  
  // 获取平台信息
  const { data: platformData } = useAPI(() => getPlatformInfo(i18n.language), [i18n.language])

  return (
    <div className="min-h-screen bg-gray-50">

      <div className="about-page">

        {/* Hero Section */}
        <section className="bg-gradient-to-r from-blue-600 to-blue-800 text-white py-16">
          <div className="container mx-auto px-4 text-center">
            <h1 className="text-4xl md:text-5xl font-bold mb-4">
              {t('about.pageTitle')}
            </h1>
            <p className="text-xl md:text-2xl text-blue-100 max-w-3xl mx-auto">
              {t('about.pageSubtitle')}
            </p>
          </div>
        </section>

        {/* 主要内容区域 */}
        <main>
          
          {/* 平台介绍 */}
          <PlatformInfo platformData={platformData} />
        </main>
       
      </div>
    </div>
  )
}

export default AboutPage 